import React from "react";
import brandMark from "assets/img/brand-mark.svg";
import lukos from "assets/img/logo-lukos.png"

/** Marca do shell (sidebar/topbar) — montanha Lukos, exibida na caixa branca. */
export default function BrandLogo({ size = 28 }) {
  return (
    <img
      src={lukos}
      alt="Fatura WEB"
      width={size}
      height={size}
      style={{ objectFit: "contain", display: "block" }}
    />
  );
}
